<template>
    <div>
        <div>
            <el-table :data="user.tableData" @row-click="rowNoticeClick" :header-cell-style="{ 'text-align': 'center' }"
                v-loading="user.loading" stripe>

                <el-table-column prop="produceId" label="商品Id" align="center"></el-table-column>
                <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="state" label="商品状态" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state == '0'">要下架</el-tag>
                        <el-tag v-if="scope.row.state == '1'">要上架</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="startTime" label="任务开始时间" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
                <el-table-column prop="operation" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="deleteTimingTask(scope.row.id)">删除任务</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="user.pageIndex"
                    :page-size="user.pageSize" :total="user.pageTotal"
                    @current-change="handleUserPageChange"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import {  } from '../../api/produce.js'

export default {
    name: 'ProduceTimingTask',
    data: function () {
        return {
            query: {
                noticeSearch: '',
                projectName: null, // 下拉框值
                deviceId: '',    // 搜索框
            },
            user: {
                tableData: [],
                pageIndex: 1,
                pageSize: 10,
                pageTotal: 1,
                loading: false
            },
        }
    },
    created() {
        this.initUserData()
    },
    activated() {
        this.initUserData()
    },
    methods: {
        //初始化数据
        initUserData() {
            this.user.loading = true
            //如果搜索框不等于 空, 添加搜索条件
            let noticeId = ''
            if (this.query.noticeSearch != '' && this.query.noticeSearch != undefined) {
                noticeId = this.query.noticeSearch
            }
            //发送请求
            let params = { 'startPage': this.user.pageIndex, 'pageCount': this.user.pageSize }
           
        },
        deleteTimingTask(id) {
            this.$confirm('确定要执行此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'

            }).then(() => {
                //发送请求
                let params = { 'id': id, "timingTask": 1 }
                modifyProduceTiming(params).then(res => {
                    if (res.status == 200) {
                        alert("删除成功")
                    }
                    this.initUserData();
                }).catch(err => {
                })
            }).catch(() => {
                // 取消操作
            });
        },

        //上一页 or 下一页
        handleUserPageChange(pageIndex) {
            this.user.pageIndex = pageIndex
            this.initUserData()
        },
    }
}
</script>

<style scoped lang="scss">
/* 鼠标悬浮 */
::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td {
    //  background-color: #212e3e !important;
    cursor: pointer;
}

.handle-input {
    width: 260px;
    display: inline-block;
    margin-right: 10px;
}
</style>
